import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const ALLOWED = ['p', 'br', 'strong', 'em', 'code', 'ul', 'ol', 'li', 'a', 'h1', 'h2', 'h3', 'h4', 'blockquote', 'hr'];

const components = {
  a: ({ node: _node, children, href }) => <a href={href} rel="noopener noreferrer" target="_blank">{children}</a>,
  // A message is not a document: headings read as bold lines, the top levels a little larger and spaced (long news).
  h1: ({ children }) => <p className="sandbox-msg-md-h is-1"><strong>{children}</strong></p>,
  h2: ({ children }) => <p className="sandbox-msg-md-h is-2"><strong>{children}</strong></p>,
  h3: ({ children }) => <p className="sandbox-msg-md-h is-3"><strong>{children}</strong></p>,
  h4: ({ children }) => <p className="sandbox-msg-md-h is-4"><strong>{children}</strong></p>,
};

/** A message's markdown (paragraphs, headings, lists, quotes, rules, bold, italic, code, http(s) links); raw HTML is shown as text, never rendered. */
export default function MessageText({ text, className }) {
  return (
    <div className={`sandbox-msg-md${className ? ` ${className}` : ''}`}>
      <ReactMarkdown allowedElements={ALLOWED} remarkPlugins={[remarkGfm]} components={components} unwrapDisallowed>{String(text || '').replace(/</g, '&lt;')}</ReactMarkdown>
    </div>
  );
}

MessageText.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
};
